import { Flex, Text } from '@chakra-ui/react'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { reportingApi } from '~/apis/reportingApi'
import { useGetAllPhoneNumbersSingleRequest } from '~/queries/phoneNumberQueries'
import { useDateRangeWithSearchParams } from '~/types/Shared'

import {
  InboundAnswerRateDashboard,
  type InboundAnswerRateDashboardHandle,
  InboundAnswerRateFilters,
  ReportingI18nProvider,
} from '@mangovoice/reporting-ui'
import type { PhoneNumber } from '@mangovoice/types'

import { useDashboardContext } from './context/DashboardContext'

export const InboundAnswerRatePage = () => {
  const { t, i18n } = useTranslation()
  const { pbxId, timeZone } = useDashboardContext()
  const [dateRange, setDateRange] = useDateRangeWithSearchParams()
  const [selectedPhoneNumbers, setSelectedPhoneNumbers] = useState<
    PhoneNumber[]
  >([])
  const [canExport, setCanExport] = useState(false)
  const dashboardRef = useRef<InboundAnswerRateDashboardHandle>(null)

  const { results: phoneNumbers, isLoading: isPhoneNumbersLoading } =
    useGetAllPhoneNumbersSingleRequest()

  return (
    <ReportingI18nProvider t={t} locale={i18n.language}>
      <Flex
        padding="1.25rem"
        flexDirection="column"
        alignItems="center"
        gap="0.25rem"
        flex="1 0 0"
        alignSelf="stretch"
        overflow="auto"
      >
        <InboundAnswerRateFilters
          dateTimeRange={dateRange}
          onValueChange={setDateRange}
          selectedPhoneNumbers={selectedPhoneNumbers}
          onPhoneNumberChange={setSelectedPhoneNumbers}
          phoneNumbers={phoneNumbers}
          isPhoneNumbersLoading={isPhoneNumbersLoading}
          onExportCsv={() => dashboardRef.current?.exportCsv()}
          isExportCsvDisabled={!canExport || !dateRange}
        />
        {dateRange ? (
          <InboundAnswerRateDashboard
            ref={dashboardRef}
            api={reportingApi}
            t={t}
            locale={i18n.language}
            sharedDateRange={dateRange}
            selectedPbxId={pbxId}
            timeZone={timeZone}
            selectedPhoneNumbers={selectedPhoneNumbers}
            onExportAvailabilityChange={setCanExport}
          />
        ) : (
          <Flex justifyContent="center" alignItems="center" height="100%">
            <Text>{t('dateTimeRange.selectDateRange')}</Text>
          </Flex>
        )}
      </Flex>
    </ReportingI18nProvider>
  )
}
